// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"fffb718d","198":"0067cd41","281":"8dd5e965","303":"006fc198","419":"b3c29c4d","498":"a3d075a3","703":"621bfe41","787":"8e8ffda9"}[chunkId] + ".chunk.js";
};